<div class="main medication-list global-table-wrapper">
    <div class="title-btn-layout">
        <div class="main-title">
            <h1>Medication List</h1>
            <p>Show your medication list information</p>
        </div>

        <div class="new-placement" *appHasRole="['Admin', 'Farm manager']">
            <a routerLink="/add-medication" class="btn btn-action-primary"
                ><i class="fas fa-plus"></i> New Medication</a
            >
        </div>
    </div>
    <div class="farm-filter">
        <app-search-filter
            [config]="medicationFilterConfig"
            [userId]="userDetail?.id"
            [externalForm]="filterForm"
            placeholder="Filter medications..."
            (filter)="onMedicationFilterApplied($event)"
            (clear)="onMedicationFilterCleared()"
        ></app-search-filter>
    </div>
    <!-- <div class="info-tile-container small-tiles">
        <app-info-tile
            [infoName]="'Expiring Soon'"
            [infoValue]="expiringSoon"
        ></app-info-tile>
        <app-info-tile
            [infoName]="'Out of Stock'"
            [infoValue]="outOfStock"
        ></app-info-tile>
        <app-info-tile
            [infoName]="'Need to be Ordered'"
            [infoValue]="needToBeOrdered"
        ></app-info-tile>
    </div> -->
    <p-table [value]="data" responsiveLayout="scroll" [loading]="loading">
        <ng-template pTemplate="header">
            <tr>
                <th>Brand</th>
                <th>Type</th>
                <th>Quantity(Boxes)</th>
                <th>Expiry Date</th>
                <th></th>
                <th></th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item.name }}</td>
                <td>
                    <span class="medi-border">{{ item.chickTypeName }}</span>
                </td>
                <td>
                    <span class="medi-border">{{ item.qty }}</span>
                </td>
                <td>{{ item.expiryDate | date: 'MM/dd/yyyy' }}</td>

                <ng-container *appHasRole="['Admin', 'Farm manager']">
                    <td>
                        <a
                            [routerLink]="['/edit-medication', item.id]"
                            pTooltip="Edit"
                            tooltipPosition="top"
                            class="table-action-icon"
                            ><i class="far fa-edit"></i
                        ></a>
                    </td>
                    <td>
                        <a
                            (click)="deleteMedication(item.id)"
                            pTooltip="Medication Delete"
                            tooltipPosition="top"
                            class="table-action-icon"
                        >
                            <i class="fas fa-trash-alt"></i>
                        </a>
                    </td>
                    <td>
                        <a
                            [routerLink]="['/medication-detail', item.id]"
                            pTooltip="Medication Detail"
                            tooltipPosition="top"
                            class="table-action-icon"
                            ><i class="fas fa-info-circle"></i
                        ></a>
                    </td>
                </ng-container>
            </tr>
        </ng-template>
    </p-table>
    <p-paginator
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        styleClass="p-paginator-bottom"
    ></p-paginator>
</div>

<!-- delete medication -->
<p-dialog
    [(visible)]="displayDeleteDialog"
    model="true"
    [closable]="true"
    [style]="{width: '400px'}"
    [responsive]="true"
>
    <p class="text-center">Are you sure you want to delete?</p>
    <div class="text-center">
        <button (click)="deleteItem()" class="btn btn-primary mr-1">Yes</button>
        <button (click)="displayDeleteDialog = false" class="btn btn-secondary">
            No
        </button>
    </div>
</p-dialog>
